import {getResidentContextErrorMessage} from "@/src/modules/core/lib/resident-context-errors";

export function getHouseholdOccupantErrorMessage(
  error: unknown,
  fallback: string,
): string {
  return getResidentContextErrorMessage(error, fallback);
}
